import React from "react";
import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import Carpet from "../components/ServiceRegions/İntros/Carpet";


const Home = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <Carpet/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default Home;
